import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { RiskItem } from "../shared/RiskList";
import HeartGraphs from "./HeartGraphs";

@Component({ components: { HeartGraphs } })
export default class Heart extends Vue {
  @Getter("config", patientNamespace)
  config!: any;

  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("darkMode", navigationNamespace)
  darkMode!: boolean;

  get currentStatus(): Array<RiskItem> {
    const currentPatient = this.current;
    if (!currentPatient) {
      return [];
    }
    const atoms = currentPatient.body.atoms;

    const status = [];
    if (atoms.bp.legend) {
      status.push({
        label: "BP=" + atoms.bp.legend.replace("|", " "),
        level: atoms.bp.level
      });
    }

    if (atoms.heartRate.legend) {
      status.push({
        label: "HR=" + atoms.heartRate.legend,
        level: atoms.heartRate.level
      });
    }

    if (atoms.volume && atoms.volume.legend !== "I/O Balance") {
      status.push({
        label: atoms.volume.legend,
        level: atoms.volume.level
      });
    }

    if (atoms.ioBalance) {
      const ioBalanceText =
        (atoms.ioBalance.value > 0 ? "I/O Balance: +" : "I/O Balance: ") +
        atoms.ioBalance.value.toFixed(0);

      status.push({
        label: ioBalanceText,
        level: atoms.ioBalance.level
      });
    }

    return status;
  }

  get medianDisclaimer() {
    return "*Data points displayed for blood pressure and heart rate are saved to the graph every 15 minutes.";
  }
}
